export default {
  boardCreation: {},
  allBoards: [],
  currentBoard: {},
  currentBoardUsers: [],
  boardUsers: [],
  userBoardData: [],
  searchedBoardUsers: false,

  // User level
  userLevelBoards: [],
  currentUserLevelBoard: {},
  currentBoardUserDetails: {},
  currentUserBoardProgress: {},

  // progress status
  fetchingBoardUsers: false,

  profileCompletionMap: {},
  coach: {},
  allArchivedBoards: [],
};
